module.exports = __webpack_public_path__ + "img/support_d6.2abe2211.png";